import { useState } from "react";
import { FiBookOpen, FiCompass, FiCornerUpLeft, FiCornerDownRight, FiSun } from "react-icons/fi";

function SceneOrbit() {
	return <><div className="hero-scene-orbit" aria-hidden="true" /><div className="hero-scene-orbit hero-scene-orbit-outer" aria-hidden="true" /></>;
}

export function HeroAppScene() {
	return (
		<div className="hero-app-scene">
			<div className="hero-discovery-art">
				<SceneOrbit />
				<div className="hero-discovery-object"><div className="hero-device-art"><img src="/images/mockup2.png" width="2400" height="2400" alt="Akello Library app showing academic books and a personal library on a mobile phone" loading="eager" /></div></div>
				<span className="hero-discovery-spark" aria-hidden="true">✳</span>
			</div>
		</div>
	);
}

export function HeroBooksScene({ onInteract }) {
	const [open, setOpen] = useState(false);
	return (
		<div className="hero-books-scene">
			<div className="hero-discovery-art">
				<SceneOrbit />
				<div className="hero-discovery-object"><div className="hero-book-fan">
					<div className="hero-art-book hero-art-book-back" aria-hidden="true"><FiSun /><span>A world of<br /><strong>new ideas.</strong></span><small>LEARN SOMETHING NEW</small></div>
					<div className="hero-art-book-front" data-open={open}>
						<div className="hero-book-paper" id="hero-illustrated-book-pages" aria-hidden={!open}><FiBookOpen aria-hidden="true" /><span className="hero-book-chapter">A LITTLE CURIOSITY</span><p>Every new chapter starts with a small question.</p><span className="hero-book-paper-lines" aria-hidden="true" /><span className="hero-book-page-number">01</span></div>
						<span className="hero-book-leaf hero-book-leaf-one" aria-hidden="true" /><span className="hero-book-leaf hero-book-leaf-two" aria-hidden="true" />
						<div className="hero-art-book hero-book-cover" aria-hidden="true"><FiCompass /><span>Somewhere<br /><strong>to get lost.</strong></span><small>FOLLOW YOUR CURIOSITY</small><span className="hero-book-corner-fold" /></div>
						<button type="button" className="hero-book-corner-toggle" aria-label={open ? "Close illustrated book" : "Open illustrated book"} aria-expanded={open} aria-controls="hero-illustrated-book-pages" title={open ? "Close the book" : "Open the book from the corner"} onClick={() => { onInteract(); setOpen(!open); }}>{open ? <FiCornerDownRight aria-hidden="true" /> : <FiCornerUpLeft aria-hidden="true" />}</button>
					</div>
				</div></div>
				<span className="hero-discovery-spark" aria-hidden="true">✳</span>
			</div>
			<p className="hero-books-hint" role="status">{open ? "There’s always another chapter to discover." : "A little curiosity? Open the book’s corner."}</p>
		</div>
	);
}
